"use strict";

// References
var alt = require("../alt");
var InventoryActions = require("../actions/InventoryActions");
var CompanyStore = require("./CompanyStore");
var AuthStore = require("./AuthenticationStore");
var _ = require("underscore");
var networking = require("../utils/Networking.js");
var Networking = new networking();

var NotificationActions = require('../actions/NotificationActions');

class InventoryStore {
    // Data
    constructor() {
        this.bindActions(InventoryActions);

        this.items = [];
        this.loading = false;
        this.filterData = {
            "query": "",
            "account": "",
            "owner": "",
            "types": [],
            "departments": [],
            "locations": [],
            "statuses": []
        };
        this.notification = {
          "type": "",
          "message": "",
          "className": "",
          "isActive": false,
          "action": "X",
          "dismissAfter": 4000
        };
        this.importResponse = {
            "duplicate_names": {
                "departments": [],
                "locations": [],
                "types": [],
                "users": []
            },
            "exists_but_no_access": {
                "departments": [],
                "locations": [],
                "types": [],
                "users": []
            },
            "need_to_create": {
                "departments": [],
                "locations": [],
                "types": [],
                "users": []
            }
        };
    }

    onClearItems() {
        this.setState({items: {}});
    }

    onGetItems() {

        this.setState({loading: true});

        var success = function(result) {

            var newState = {};
            newState.items = _.indexBy(result, "id");
            newState.loading = false;
            this.setState(newState);

        }.bind(this);

        var failure = function(error) {

            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Tókst ekki að sækja búnað",
                level: 'error'
            }
            NotificationActions.createNotification(notification);
            console.error("getItems() fail", error);

        }.bind(this);

        Networking.GET("items/", success, failure);
    }

    onAddItem(data) {
        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: data.name+" bætt við",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onRefreshItems();
        }.bind(this);

        var failure = function(error) {
            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Ekki tókst að bæta "+data.name+" við",
                level: 'error'
            }
            NotificationActions.createNotification(notification);
            console.error("addItem() fail", error);
        }.bind(this);

        // This is a hack solution because there is no proper form validation in the client
        // and the server validation of the brand field was to much problem
        // If the brand field is missing then we set the require field department to null
        if (!data.brand || data.brand === '' || data.brand === 'Veldu vörumerki') {
          data.department = null;
        }

        Networking.POST("items/", data, success, failure);
    }

    onImportItems(data) {

        var success = function(result) {
            var newState = {};
            newState["importResponse"] = result;
            this.setState(newState);

            var notification = {
                title: "Aðgerð tókst!",
                message: "Sjálfvirkur innflutningur tókst!",
                level: 'success'
            }
            NotificationActions.createNotification(notification);

        }.bind(this);

        var failure = function(error) {

            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Sjálfvirkur innflutningur mistókst",
                level: 'error'
            }
            NotificationActions.createNotification(notification);
            console.error("importItems() fail", error)

        }.bind(this);

        Networking.IMPORT(data, success, failure);
    }

    onEditItem(data) {

        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: data.name+" hefur verið breytt",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onRefreshItems();
        }.bind(this);
        var failure = function(error) {
            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Ekki tókst að breyta "+data.name,
                level: 'error'
            }
            NotificationActions.createNotification(notification);
            console.error("editItem() fail", error);
        }.bind(this);

        Networking.PUT("items/"+data.id+"/", data, success, failure);
    }

    onDeleteItem(id) {

        var success = function(result) {

            var notification = {
                title: "Aðgerð tókst!",
                message: this.items[id].name+" hefur verið eytt",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onRefreshItems();

        }.bind(this);

        var failure = function(error) {

            if (error.responseJSON.detail && error.responseJSON.detail !== "") {
                message = error.responseJSON.detail;
            }
            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: message,
                level: 'error'
            }
            NotificationActions.createNotification(notification);
            console.error("deleteItem() fail", error)

        }.bind(this);

        Networking.DELETE("items/"+id+"/", success, failure);
    }

    onFilterEquipment(data) {
      this.setState({ loading: true });
      var success = function(result) {
          var newState = {};
          newState["filterData"] = data;
          newState["filterId"] = result.id;
          newState["items"] = _.indexBy(result.items, "id");
          newState.loading = false;
          this.setState(newState);
          // this.onGetItems();
      }.bind(this);

      var failure = function(error) {
          console.error("filterEquipment() fail", error)
          var newState = {};
          newState.loading = false;
          this.setState(newState);

          var message = "Ekki tókst að sía lista";
          if (error.responseJSON.detail && error.responseJSON.detail !== "") {
              message = error.responseJSON.detail;
          }
          var notification = {
              title: "Eitthvað fór úrskeiðis!",
              message: message,
              level: 'error'
          }
          NotificationActions.createNotification(notification);

      }.bind(this);
      Networking.POST("filters/", data, success, failure);
    }

    onRefreshFilter() {
        var account = AuthStore.getState().account;
        var owner = AuthStore.getState().id;
        if(account && owner){
            var filterData = this.filterData;
            filterData.account = account;
            filterData.owner = owner;
            this.onFilterEquipment(filterData);
        }
    }

    onClearFilter() {
        var account = AuthStore.getState().account;
        var owner = AuthStore.getState().id;
        if(account && owner){
            var filterData = {};
            filterData.account = account;
            filterData.owner = owner;
            filterData.query = "";
            filterData.types = [];
            filterData.departments = [];
            filterData.locations = [];
            filterData.statuses = [];
            this.filterData = filterData;
            this.onGetItems();
        }
    }

    onRefreshItems() {
        if(this.filterData.account && this.filterData.owner){
            this.onFilterEquipment(this.filterData);
        } else {
            this.onGetItems();
        }
    }

    onCommentOnItem(data) {

        var success = function(result) {

            var notification = {
                title: "Aðgerð tókst!",
                message: "Athugasemdin þín hefur verið skráð",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onRefreshItems();

        }.bind(this);

        var failure = function(error) {

            if (error.responseJSON.detail && error.responseJSON.detail !== "") {
                message = error.responseJSON.detail;
            }
            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: message,
                level: 'error'
            }
            NotificationActions.createNotification(notification);
            console.error("deleteItem() fail", error)

        }.bind(this);

        var account = AuthStore.getState().account;
        var owner = AuthStore.getState().id;

        if(account && owner){
            data.account = account;
            data.owner = owner;
        }

        Networking.POST("comments/", data, success, failure);
    }
}

var inventoryStore = alt.createStore(InventoryStore, "InventoryStore");

window.inventoryStore = inventoryStore;

module.exports = inventoryStore;



// WEBPACK FOOTER //
// ./app/scripts/stores/InventoryStore.js